import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ComposerProductFileInterface } from 'src/app/model/composer/composer-product-file-interface';
import { ComposerService } from 'src/app/services/composer-service/composer.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { ModelEditorComponent } from '../model-editor/model-editor.component';

@Component({
    selector: 'app-composer-editor-screen',
    templateUrl: './composer-editor-screen.component.html',
    styleUrls: ['./composer-editor-screen.component.css'],
    standalone: false
})
export class ComposerEditorScreenComponent implements OnInit {
    public blankLayout: string =
        '<?xml version="1.0" encoding="UTF-8"?><bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:composer="http://composer.bimswarm.de/definition" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn"><bpmn:process id="PNeuerProzess" logo="" logoDataUrl="" toolchainInstances="Meine Toolchain v2:;:;Meine Toolchain v3" externalId="" organisation="-1" creatorId="CREATORIDREPLACE" creator="CREATORNAMEREPLACE" lastChanges="19.10.2020" name="Neue Toolchain" description="Neue Beschreibung" isExecutable="false"></bpmn:process><bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="PNeuerProzess"></bpmndi:BPMNPlane></bpmndi:BPMNDiagram></bpmn:definitions>';

    public xml: string;
    public xmlFileIds: ComposerProductFileInterface[];

    private paramSubscription: Subscription;
    private xml_original: string;

    @ViewChild(ModelEditorComponent)
    private modelEditorComponent: ModelEditorComponent;

    public validToolchain: boolean;

    constructor(
        private composerService: ComposerService,
        private changeDetector: ChangeDetectorRef,
        private readonly route: ActivatedRoute,
        private router: Router,
        private userService: UserService
    ) {}

    ngOnInit() {
        this.paramSubscription = this.route.paramMap.subscribe(
            async (params) => {
                const toolchainIdParameter = params.get('toolchainId');

                if (toolchainIdParameter === 'new') {
                    this.xml = this.customizedBlankLayout();
                    this.xmlFileIds = [];
                    this.changeDetector.detectChanges();
                } else {
                    const toolchainId = parseInt(toolchainIdParameter);

                    this.composerService
                        .loadXMLForToolchain(toolchainId)
                        .subscribe((xmlAndFileIds) => {
                            if (xmlAndFileIds) {
                                this.xml = xmlAndFileIds.xml;
                                this.xmlFileIds = xmlAndFileIds.fileIds;
                                if (!this.changeDetector['destroyed']) {
                                    this.changeDetector.detectChanges();
                                }
                                this.xml_original = this.xml;
                            }
                        });
                }
            }
        );
    }

    ngOnDestroy() {
        if (this.paramSubscription) {
            this.paramSubscription.unsubscribe();
        }
    }

    /* Redirects to the Overview Page */
    public goToOverviewPage() {
        this.router.navigateByUrl('/composer');
    }

    /* Saves the Toolchain to the Backend */
    public saveToolchain() {
        this.modelEditorComponent.saveModel(this.xml_original);
    }

    /* Customizes the Blank Layout and adds the correct Values for the Replace Elements */
    private customizedBlankLayout(): string {
        let customized = this.blankLayout;

        customized = customized.replace(
            'CREATORIDREPLACE',
            this.userService.currentUser.userId.toString()
        );
        customized = customized.replace(
            'CREATORNAMEREPLACE',
            this.userService.currentUser.lastName +
                ', ' +
                this.userService.currentUser.firstName.substring(0, 1) +
                '.'
        );
        //TODO TOOLCHAIN INSTANCES

        return customized;
    }

    public changeToolchainValidity(valid: boolean) {
        this.validToolchain = valid;
    }
}
